import React, { useEffect } from 'react';
import { useState, Downgraded, createState } from '@hookstate/core';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import {
    Box,
    Grid,
    Typography,
    Divider,
    RadioGroup,
    Radio,
    Select,
    MenuItem,
    InputLabel,
    TextField,
    FormControl,
    FormControlLabel,
    FormHelperText,
} from '@mui/material';
import { updateModuleState } from '../../stores/eventStore';
import { makeStyles } from '@mui/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import Stack from '@mui/material/Stack';
// import validator from 'validator';
// import InputMask from 'react-input-mask';
import { useEventState } from '../../stores/eventStore';
import { useAgentState } from '../../hookState/AgentState';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../constants/Constant';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import AppConstants from '../../constants/appConstants';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import SedanBlue from '../../assets/images/sedan_blue.svg';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import Title from '../../sharedcomponents/title/title';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import MUIDatePicker from '../../sharedcomponents/datePicker';
//import { setUserAgent } from 'react-device-detect';

const passengerCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});
const transportState = createState({
    transportID: 0,
    useTransport: 1,
    addedFor: '',
    totalPassengers: 0,
    pickupDate: null,
    pickupTime: null,
    pickupAddress: '',
    dropOffAddress: '',
    priContactName: '',
    priContactEmail: '',
    priContactNo: '1',
    backupContactName: '',
    backupContactEmail: '',
    backupContactNo: '',
    createdBy: null,
    isDisable: false
});
const CreateNightTransport = (props) => {
    const classes = useStyles();
    const loading = useState(false);
    const eventState = useEventState();
    const state = useState(transportState);
    let params = useParams();
    const history = useHistory();
    const agentState = useAgentState();
    const [participant, setParticipant] = React.useState(null);
    // const [autoApprove, setAutoApprove] = React.useState(0);
    const [modPermission, setModPermission] = React.useState(null);
    const [participantList, setParticipantList] = React.useState(null);
    const [prevVipInfo, setPrevVipInfo] = React.useState()
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const regex = new RegExp('[^\\s]+')
    // errors
    const [useTransportErr, setUseTransportErr] = React.useState('');
    const [passengerErr, setPassengerErr] = React.useState('');
    const [dateTimeErr, setDateTimeErr] = React.useState('');
    const [timeErr, setTimeErr] = React.useState('');
    const [pickupAddressErr, setPickupAddressErr] = React.useState('');
    const [dropOffAddressErr, setDropOffAddressErr] = React.useState('');
    const [priContactNameErr, setPriContactNameErr] = React.useState('');
    const [priContactEmailErr, setPriContactEmailErr] = React.useState('');
    const [priContactNoErr, setPriContactNoErr] = React.useState('');
    const [backupContactNameErr, setBackupContactNameErr] = React.useState('');
    const [backupContactEmailErr, setBackupContactEmailErr] = React.useState('');
    const [showLoading, setShowLoading] = React.useState(false);
    // const [backupContactNoErr, setBackupContactNoErr] = React.useState('');

    const [pickupConfigDate, setPickupConfigDate] = React.useState('');
    const eventInfo = Helper.getStorage('eventInfo');

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState.get() && eventState.eventDetail.get() != null) {

            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(
                            permissions,
                            'ALLSTARHOTEL'
                        )
                    );
                }
            }
            // if (!Helper.isAdminUser(userInfo))
            // {
            //     const permissions = eventState.permissions
            //         .attach(Downgraded)
            //         .get();
            //     if (permissions && permissions.length > 0)
            //     {
            //         setModPermission(
            //             Helper.getModuleAccessPermission(
            //                 permissions,
            //                 'SATNIGHTTRANSPORT'
            //             )
            //         );
            //     }
            // } else if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))
            // {
            //     setModPermission(FULL_PERMISSION);
            // }
        }
    }, [eventState]);
    useEffect(() => {
        // const eventInfo = Helper.getStorage('eventInfo');
        // ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false))
        //     .then((res) =>
        //     {
        //         if (res.data)
        //         {
        //             res.data.map((auto) =>
        //             {
        //                 if (auto.moduleName === "SatNightTransport")
        //                 {
        //                     setAutoApprove(auto.autoApprove)
        //                 }
        //             })
        //         }
        //     })
        getEventDefaults()
    }, [])
    const getEventDefaults = () => {
        const gEventInfo = Helper.getStorage('eventInfo');

        return ApiHelper.get(APIURLConstants.GET_EVENT_CONFIG(gEventInfo.eventID)).then(res => {
            // console.log("res", res);
            if (res.data && res.data.length > 0) {
                res.data.map((item) => {
                    if (item.moduleID === 12 && item.key === "PickupDate") {
                        setPickupConfigDate(item.description)
                        state.pickupDate.set(item.description);
                    }
                })
            }
        })
    }

    useEffect(() => {
        if (modPermission && modPermission == FULL_PERMISSION) {

            if (params.transitID) {
                state.transportID.set(params.transitID);
                const transportState = history.location.state.transportState;
                state.set({
                    transportID: transportState.transportID,
                    useTransport: transportState.useTransport,
                    addedFor: transportState.addedFor,
                    totalPassengers: transportState.totalPassengers,
                    pickupDate: transportState.pickupDate,
                    pickupTime: Helper.FormatTime24(transportState.pickupDate),
                    pickupAddress: transportState.pickupAddress,
                    dropOffAddress: transportState.dropOffAddress,
                    priContactName: transportState.priContactName,
                    priContactEmail: transportState.priContactEmail,
                    priContactNo: transportState.priContactNo,
                    backupContactName: transportState.backupContactName,
                    backupContactEmail: transportState.backupContactEmail,
                    backupContactNo: transportState.backupContactNo,
                    createdBy: null,
                    isDisable: false
                });
                setPrevVipInfo({
                    transportID: transportState.transportID,
                    useTransport: parseInt(transportState.useTransport),
                    addedFor: transportState.addedFor,
                    totalPassengers: transportState.totalPassengers,
                    pickupDate: transportState.pickupDate,
                    pickupTime: Helper.FormatTime24(transportState.pickupDate),
                    pickupAddress: transportState.pickupAddress,
                    dropOffAddress: transportState.dropOffAddress,
                    priContactName: transportState.priContactName,
                    priContactEmail: transportState.priContactEmail,
                    priContactNo: transportState.priContactNo,
                    backupContactName: transportState.backupContactName,
                    backupContactEmail: transportState.backupContactEmail,
                    backupContactNo: transportState.backupContactNo,
                    createdBy: null,
                    isDisable: false
                })
            } else {
                state.transportID.set(0);
                resetState()
            }

            const gEventInfo = Helper.getStorage('eventInfo');
            const gUserInfo = Helper.getStorage('userInfo');

            if (
                Helper.isAdminUser(gUserInfo) ||
                (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
            ) {
                const transportStates = history.location.state.transportState;

                ApiHelper.get(
                    APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                        gEventInfo.eventID
                    )
                ).then((res) => {
                    if (res.data.rows) {
                        const participants = res.data.rows.filter(
                            (participant) =>
                                AppConstants.EVENT_ROLES_VALUES.indexOf(
                                    participant.roleName
                                ) == -1
                        );
                        if (params.transitID && history.location.state.transportState) {
                            const editParticipant = res.data.rows.filter(
                                (participant) => participant.userID === transportStates.addedFor)
                            setParticipant(editParticipant[0])
                            setParticipantList(participants);
                        } else {
                            setParticipantList(history.location.state.participantList);
                        }
                    }
                });
            }
        }
    }, [modPermission]);

    useEffect(() => {
        if (params && params.transitID) {
            state.transportID.set(params.transitID);
        }
        else {
            state.transportID.set(0);
        }
    }, [params])

    // console.log(backupContactNameErr, backupContactEmailErr, backupContactNoErr);
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!isValidForm()) {
            return false;
        }
        else {
            // if (passengerErr.length > 0 || pickupAddressErr.length > 0 || dropOffAddressErr.length > 0 || priContactNameErr.length > 0 || priContactEmailErr.length > 0 || priContactNoErr.length > 0 ||
            //     backupContactNameErr.length > 0 || backupContactEmailErr.length > 0 || backupContactNoErr.length > 0)
            // {
            //     return false
            // }
            // else
            // {

            const eventInfo = Helper.getStorage('eventInfo');
            const userInfo = Helper.getStorage('userInfo');
            const agentInfo = Helper.getStorage('agentInfo');
            let reqObj
            if (parseInt(state.useTransport.value)) {
                reqObj = {
                    transportID: state.transportID.value,
                    eventID: eventInfo.eventID,
                    useTransport: parseInt(state.useTransport.value),
                    addedFor: participant ? participant.userID : userInfo.userID,
                    totalPassengers: state.totalPassengers.value,
                    pickupDate: parseInt(state.useTransport.value) === 1 ? `${Helper.FormatYearDate(
                        state.pickupDate.get()
                    )}T${state.pickupTime.get()}:00` : new Date(),
                    pickupAddress: state.pickupAddress.value,
                    dropOffAddress: state.dropOffAddress.value,
                    priContactName: state.priContactName.value,
                    priContactEmail: state.priContactEmail.value,
                    priContactNo: state.priContactNo.value,
                    backupContactName: state.backupContactName.value,
                    backupContactEmail: state.backupContactEmail.value,
                    backupContactNo: state.backupContactNo.value,
                    createdBy: userInfo.userID
                }
            } else {
                reqObj = {
                    transportID: state.transportID.value,
                    eventID: eventInfo.eventID,
                    useTransport: parseInt(state.useTransport.value),
                    addedFor: participant ? participant.userID : userInfo.userID,
                    totalPassengers: 0,
                    pickupDate: '',
                    pickupAddress: '',
                    dropOffAddress: '',
                    priContactName: '',
                    priContactEmail: '',
                    priContactNo: '',
                    backupContactName: '',
                    backupContactEmail: '',
                    backupContactNo: '',
                    createdBy: userInfo.userID
                }
            }
            setShowLoading(true);
            ApiHelper.post(APIURLConstants.ADD_UPDATE_SAT_NIGHT_TRANSPORT, reqObj)
                .then(async (res) => {
                    if (res.status === 200) {
                        if (state.transportID.value > 0) {
                            setShowLoading(false);
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Request updated successfully',
                            });
                        }
                        else {
                            setShowLoading(false);
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: 'Request created successfully',
                            });
                        }
                        // if (autoApprove === 1 || state.transportID.value > 0)
                        // {
                        // if (parseInt(state.useTransport.value) === 1)
                        // {
                        // await SETEmailNotification(reqObj);
                        // }

                        // }
                        setTimeout(() => {
                            resetState();
                            state.isDisable.set(false);
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
                            ) {
                                props.history.push(
                                    generatePath(
                                        RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_LIST,
                                        { eventID: eventInfo.eventID }
                                    )
                                );
                            } else {
                                props.history.push(
                                    generatePath(RouteConstants.EVENT_SAT_NIGHT_TRANSPORT, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                                updateModuleState()
                            }
                        }, 1000);
                        setShowLoading(false);
                    }
                })
                .catch((err) => {
                    setShowLoading(false);
                    console.log(err);
                });
        }
        // else if (true){
        //     alert("inside");
        // }
        //const userInfo = Helper.getStorage('userInfo');
    }

    const isValidForm = () => {
        let isValid = true;
        console.log(state.pickupTime.value, "kk", state.useTransport.value);

        if (state.useTransport.value == null) {
            setUseTransportErr('Please select transportation option');
            isValid = false;
        } else {
            setUseTransportErr('');
            console.log("state.useTransport.value", state.useTransport.value);
            if (parseInt(state.useTransport.value)) {
                if (state.totalPassengers.value == 0) {
                    setPassengerErr('Please select number of passengers');
                    isValid = false;
                } else if (state.pickupDate.value == null) {
                    setDateTimeErr('Please select Pickup Date');
                    isValid = false;
                } else if (state.pickupTime.value == null || state.pickupTime.value.length == 0) {
                    setTimeErr('Please select Time');
                    isValid = false;
                }
                else if (state.pickupAddress.get().trim().length == 0) {
                    // eslint-disable-next-line no-debugger
                    setPassengerErr('');
                    setPickupAddressErr('Please enter pickup location');
                    isValid = false;
                }
                else if (!Helper.validName(state.pickupAddress.get().trim())) {
                    // eslint-disable-next-line no-debugger
                    setPassengerErr('');
                    setPickupAddressErr('Please enter valid pickup location');
                    isValid = false;
                }
                // else if (state.pickupAddress.get().trim().length > 0) {
                //     setPickupAddressErr('');
                //     isValid = false;
                // }
                else if (state.dropOffAddress.value.trim().length == 0) {
                    setPickupAddressErr('');
                    setDropOffAddressErr('Please enter drop off location');
                    isValid = false;
                }
                else if (!Helper.validName(state.dropOffAddress.get().trim())) {
                    // eslint-disable-next-line no-debugger
                    setPassengerErr('');
                    setDropOffAddressErr('Please enter valid drop off location');
                    isValid = false;
                }
                // else if (state.dropOffAddress.value.trim().length > 0) {
                //     setDropOffAddressErr('');
                //     isValid = false;
                // }
                else if (state.priContactName.value.trim().length == 0) {
                    setDropOffAddressErr('');
                    setPriContactNameErr('Please enter primary contact name');
                    isValid = false;
                }
                else if (!Helper.validName(state.priContactName.get().trim())) {
                    // eslint-disable-next-line no-debugger
                    setDropOffAddressErr('');
                    setPriContactNameErr('Please enter valid primary contact name');
                    isValid = false;
                }
                // else if (state.priContactName.value.trim().length > 0) {
                //     setPriContactNameErr('');
                // }
                else if (state.priContactEmail.value.trim().length == 0) {
                    setPriContactNameErr('');
                    setPriContactEmailErr('Please enter primary contact email');
                    isValid = false;
                }
                else if (!Helper.validEmail(state.priContactEmail.get().trim())) {
                    // eslint-disable-next-line no-debugger
                    setPriContactNameErr('');
                    setPriContactEmailErr('Please enter valid primary contact email');
                    isValid = false;
                }
                // else if (state.priContactEmail.value.trim().length > 0) {
                //     setPriContactEmailErr('');
                // }
                else if (state.priContactNo.value.trim().length == 0 || state.priContactNo.value.trim().length == '1') {
                    setPriContactEmailErr('');
                    setPriContactNoErr('Please enter primary contact number');
                    isValid = false;
                }
                // else if (
                //     !state.priContactNo.value.trim().match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)
                // )
                // {
                //     setPriContactEmailErr('');
                //     setPriContactNoErr('Please enter valid primary contact number');
                //     isValid = false;
                // }
                else if (state.backupContactName.value.trim().length !== 0 && !Helper.validName(state.backupContactName.get().trim())) {
                    setPriContactNoErr('');
                    setBackupContactNameErr('Please enter valid back up contact name');
                    isValid = false;
                }

                else if (state.backupContactEmail.value.trim().length !== 0 && !Helper.validEmail(state.backupContactEmail.get().trim())) {
                    setBackupContactNameErr('');
                    setBackupContactEmailErr('Please enter valid back up contact email');
                    isValid = false;
                }

                // else if (state.backupContactNo.value.trim().length !== 0 && !state.backupContactNo.value.trim().match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/))
                // {
                //     setBackupContactEmailErr('');
                //     setBackupContactNoErr('Please enter valid back up contact number');
                //     isValid = false;
                // } 
                // else
                // {
                //     setBackupContactNoErr('');
                // }
            }
            else {
                setPassengerErr('');
                setDateTimeErr('');
                setTimeErr('');
                setPickupAddressErr('');
                setDropOffAddressErr('');
                setPriContactNameErr('');
                setPriContactEmailErr('');
                setPriContactNoErr('');
                setBackupContactNameErr('');
                setBackupContactEmailErr('');
                // setBackupContactNoErr('');
            }
        }
        return isValid;
    }

    const resetState = () => {
        state.set({
            transportID: 0,
            useTransport: 1,
            addedFor: '',
            totalPassengers: 0,
            pickupDate: new Date(),
            pickupTime: null,
            pickupAddress: '',
            dropOffAddress: '',
            priContactName: '',
            priContactEmail: '',
            priContactNo: '1',
            backupContactName: '',
            backupContactEmail: '',
            backupContactNo: '',
            createdBy: null,
            isDisable: false
        });
        setUseTransportErr('');
        setPassengerErr('');
        setDateTimeErr('');
        setTimeErr('');
        setPickupAddressErr('');
        setDropOffAddressErr('');
        setPriContactNameErr('');
        setPriContactEmailErr('');
        setPriContactNoErr('');
        setBackupContactNameErr('');
        setBackupContactEmailErr('');
        // setBackupContactNoErr('');
    }
    const handleBtnCancel = () => {
        setShowLoading(false);
        resetState();
        props.history.goBack();
        handleDisableBtn();
        // props.history.push(RouteConstants.EVENT_TRANSIT);
    };

    const changeParticipant = (participant) => {
        setParticipant(participant);
    }

    const handleDisableBtn = () => {
        if (prevVipInfo != undefined) {
            const info = prevVipInfo;
            let prevData = {
                totalPassengers: info.totalPassengers,
                pickupDate: info.pickupDate,
                pickupTime: info.pickupTime,
                pickupAddress: info.pickupAddress,
                dropOffAddress: info.dropOffAddress,
                priContactName: info.priContactName,
                priContactEmail: info.priContactEmail,
                priContactNo: info.priContactNo,
                backupContactName: info.backupContactName,
                backupContactEmail: info.backupContactEmail,
                backupContactNo: info.backupContactNo,
                useTransport: parseInt(info.useTransport),
            }
            let currentData = {
                totalPassengers: state.totalPassengers.get(),
                pickupDate: state.pickupDate.get(),
                pickupTime: state.pickupTime.get(),
                pickupAddress: state.pickupAddress.get(),
                dropOffAddress: state.dropOffAddress.get(),
                priContactName: state.priContactName.get(),
                priContactEmail: state.priContactEmail.get(),
                priContactNo: state.priContactNo.get(),
                backupContactName: state.backupContactName.get(),
                backupContactEmail: state.backupContactEmail.get(),
                backupContactNo: state.backupContactNo.get(),
                useTransport: parseInt(state.useTransport.get()),
            }
            // console.log(prevData, currentData);
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }

    }
    const handleDateTime = (event) => {
        let date = `${Helper.FormatYearDate(
            event
        )}T${Helper.FormatTime24(event)}:00`
        state.pickupDate.set(date);

        if (
            state.transportID.get() == 0 &&
            moment(state.pickupDate.get()).isBefore(new Date(), 'day')
        ) {
            state.dateTimeErrorMsg.set(
                'Pickup time should be minimum todays date'
            );

        } else if (moment(state.pickupDate.get()).isValid() == false) {
            state.dateTimeErrorMsg.set('Please select valid date & time');
        } else {
            state.dateTimeErrorMsg.set('');
            setDateTimeErr('')
        }
        handleDisableBtn();
    };

    // const checkValidPhone = (type) =>
    // {
    //     const phone = (type == 'pri') ? state.priContactNo.value : state.backupContactNo.value;
    //     if (phone === "")
    //     {
    //         (type == 'pri') ? setPriContactNoErr('please enter contact number') : null;
    //     } else
    //         if (phone != '' && phone != '(___) ___-____')
    //         {
    //             if (
    //                 !phone.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)
    //             )
    //             {
    //                 (type == 'pri') ? setPriContactNoErr('Please enter valid contact number') : setBackupContactNoErr('Please enter valid contact number');

    //             } else
    //             {
    //                 (type == 'pri') ? setPriContactNoErr('') : setBackupContactNoErr('');

    //             }
    //         }
    //         else
    //         {
    //             (type == 'pri') ? setPriContactNoErr('') : setBackupContactNoErr('');
    //         }
    // };


    const validateEmail = (type) => {
        const value = type == 'pri' ? state.priContactEmail.value.trim() : state.backupContactEmail.value.trim();
        //state.email.set(value);
        if (!Helper.validEmail(value)) {
            (type == 'pri') ? setPriContactEmailErr('Please enter valid primary contact email') : null;
        } else {
            (type == 'pri') ? setPriContactEmailErr('') : setBackupContactEmailErr('');
        }
    }

    const validateName = (type) => {
        const value = type == 'pri' ? state.priContactName.value : state.backupContactName.value;
        if (!Helper.validName(value)) {
            (type == 'pri') ? setPriContactNameErr('Please enter valid name') : setBackupContactNameErr('Please enter valid name');
        } else {
            (type == 'pri') ? setPriContactNameErr('') : setBackupContactNameErr('');
            return true;
        }
    }

    const validAddress = (type) => {
        const value = type == 'pickup' ? state.pickupAddress.value : state.dropOffAddress.value;
        if (value.trim().length == 0) {
            (type == 'pickup') ? setPickupAddressErr('Please enter pick up location') : setDropOffAddressErr('Please enter drop off location');
            return false;
        }
        else {
            (type == 'pickup') ? setPickupAddressErr('') : setDropOffAddressErr('');
            return true;
        }
    }
    const handleChangePassenger = (data) => {
        state.totalPassengers.set(data.target.value);
        setPassengerErr('');
    }

    // const SETEmailNotification = (ObjRequest) =>
    // {
    //     return ApiHelper.post(
    //         APIURLConstants.POST_SET_SAT_NIGHT_EMAIL_NOTIFICATION,
    //         ObjRequest
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    // console.log("state.useTransport.get()",state.get());
    return (
        <Box sx={{ width: '100%' }}>
            <Box
                className="otherContentBox"
                sx={{
                    // p: 2,
                    '& .MuiGrid-item': { p: 2 },
                    '& .MuiFormControl-root': { width: '100%' },
                }}>
                <>
                    {loading.get() ? (
                        <Box style={loader}>
                            <CircularProgress />
                        </Box>
                    ) :
                        modPermission && modPermission == NO_ACCESS_PERMISSION ?
                            <UnauthorizedUI showLogout={false} />
                            :
                            <Box
                                component="form"
                                sx={{ width: '100%', backgroundColor: '#fff' }}
                                onSubmit={handleSubmit}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', md: 'row' },
                                        flex: 1,
                                        alignItems: 'center',
                                        margin: '10px'
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}>
                                        <Box
                                            component="img"
                                            className={classes.mobileLogo}
                                            alt="logo."
                                            src={SedanBlue}
                                        />
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                paddingLeft: 3,
                                            }}>
                                            <Title
                                                title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                                                    AppConstants.EVENT_MODULES.SAT_NIGHT_TRANSPORT)}
                                                sx={{
                                                    pb: 1,
                                                }}
                                            />
                                            {/* <Typography
                                                variant="h4"
                                                fontSize={{ xs: '15px', md: '22px' }}
                                                fontWeight={300}
                                                fontFamily={'Action NBA'}
                                                color="primary"
                                                pb={1}>
                                                Saturday Night Transport
                                            </Typography> */}
                                        </Box>
                                    </Box>

                                    <Divider
                                        orientation="vertical"
                                        light={false}
                                        sx={{ marginLeft: 2, marginRight: 5 }}
                                        flexItem
                                    />

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flex: 0.4,
                                        }}>

                                        <ParticipantAutoList
                                            disableParticipant={history.location.state.transportState ? true : false}
                                            participantID={state.transportID.value > 0 ? state.addedFor.value : null}
                                            participant={participant}
                                            setParticipant={changeParticipant}
                                            participantList={participantList}
                                            modPermission={modPermission}
                                        />

                                    </Box>
                                </Box>
                                <Divider
                                    light={false}
                                    sx={{ marginTop: 2, marginRight: 0 }}
                                    flexItem
                                />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        pt: 1,
                                        pb: 1,
                                        flex: 1,
                                    }}>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.32,
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        flexFlow: 'wrap',
                                    }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={15}
                                            fontWeight={700}
                                            fontFamily={'Lato'}
                                            noWrap
                                            fontStyle="normal"
                                            color='primary'
                                            component="div"
                                            sx={{
                                                ml: 1,
                                                mr: 1
                                            }}
                                        >
                                            Do you need transportation to All Star Saturday Night events?
                                        </Typography>
                                        {/* <Title
                                            title={'Do you need transportation to All Star Saturday Night events?'}
                                            // addicon="land"
                                            sx={{
                                                ml: 1,
                                            }}
                                        /> */}
                                    </Box>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: 0.4,
                                        position: 'relative',
                                        top: '3px'
                                    }}>
                                        <FormControl component="fieldset" error={useTransportErr.length > 0 ? true : false}>
                                            <RadioGroup
                                                row
                                                aria-labelledby="sat-night-transport"
                                                name="useTransport"
                                                value={state.useTransport.get()}
                                                onChange={(event) => {
                                                    state.useTransport.set(
                                                        event.target.value
                                                    );
                                                    handleDisableBtn()
                                                }
                                                }
                                            >
                                                <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                                <FormControlLabel value={0} control={<Radio />} label="No" />
                                            </RadioGroup>
                                            <FormHelperText>{useTransportErr}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Box sx={state.useTransport.get() == 1 ? { display: 'block' } : { display: 'none' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            pt: 1,
                                            pb: 1,
                                            justifyContent: 'flex-start',
                                        }}>
                                        <Box sx={{
                                            width: '15%',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <Typography
                                                variant="h4"
                                                flexGrow={1}
                                                fontSize={15}
                                                fontWeight={700}
                                                fontFamily={'Lato'}
                                                noWrap
                                                fontStyle="normal"
                                                color='primary'
                                                component="div"
                                                sx={{
                                                    ml: 1,
                                                }}
                                            >
                                                Number of Passengers
                                            </Typography>
                                            {/* <Title
                                                title={'Number of Passengers'}
                                                // addicon="land"
                                                sx={{
                                                    ml: 1,
                                                    mr: 1,
                                                }}
                                            /> */}
                                        </Box>
                                        <Box sx={{
                                            width: '20%',
                                        }}>
                                            <FormControl size="small" error={passengerErr.length > 0 ? true : false}>
                                                <InputLabel id="demo-simple-select-label">
                                                    Select Passengers
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={state.totalPassengers.get()}
                                                    label={'Select Passengers'}
                                                    onChange={(e) => { handleChangePassenger(e); handleDisableBtn() }}
                                                >
                                                    {passengerCount.map((option) => (
                                                        <MenuItem
                                                            key={`passanger_${option}`}
                                                            value={option}>
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText>{passengerErr}</FormHelperText>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                    <Grid
                                        container
                                        rowSpacing={2}
                                        columnSpacing={1}
                                        sx={{
                                            padding: 0,
                                            alignItems: 'flex-end'
                                            // marginTop:,
                                        }}>
                                        <Grid item lg={3} md={6} xs={12} sx={{ mt: 3 }} >
                                            <MUIDatePicker
                                                label="Start Date"
                                                value={state.transportID.get() > 0 ? (state.pickupDate
                                                    .attach(Downgraded)
                                                    .get() === '01/01/1900 00:00:00' ? '' : state.pickupDate
                                                        .attach(Downgraded)
                                                        .get()) :
                                                    pickupConfigDate !== ''
                                                        ? moment(pickupConfigDate)
                                                        : ''}
                                                error={dateTimeErr}
                                                setValue={handleDateTime}
                                            // minDate={
                                            //     pickupConfigDate !== ''
                                            //         ? new Date(pickupConfigDate)
                                            //         : new Date()
                                            // }
                                            // maxDate={
                                            //     pickupConfigDate !== ''
                                            //         ? new Date(pickupConfigDate)
                                            //         : new Date()
                                            // }
                                            />
                                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label="Start Date"
                                                    value={state.transportID.get() > 0 ? (state.pickupDate
                                                        .attach(Downgraded)
                                                        .get() === '01/01/1900 00:00:00' ? '' : state.pickupDate
                                                            .attach(Downgraded)
                                                            .get()) :
                                                        pickupConfigDate !== ''
                                                            ? moment(pickupConfigDate)
                                                            : ''}
                                                    inputProps={{ readOnly: true }}
                                                    allowKeyboardControl={false}
                                                    minDate={
                                                        pickupConfigDate !== ''
                                                            ? new Date(pickupConfigDate)
                                                            : new Date()
                                                    }
                                                    maxDate={
                                                        pickupConfigDate !== ''
                                                            ? new Date(pickupConfigDate)
                                                            : new Date()
                                                    }
                                                    onChange={(newValue) =>
                                                    {
                                                        handleDateTime(newValue); handleDisableBtn()
                                                    }
                                                    }
                                                    cancelText
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            required
                                                            size="small"
                                                            helperText={dateTimeErr}
                                                            autoComplete="off"
                                                            onKeyDown={(e) =>
                                                                e.preventDefault()
                                                            }
                                                            error={
                                                                dateTimeErr.length > 0
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider> */}
                                        </Grid>
                                        <Grid item lg={3} md={6} xs={12} sx={{ mt: 3 }} >
                                            <Stack component="form" noValidate spacing={3}>

                                                <TextField
                                                    required
                                                    id="time"
                                                    label="Time"
                                                    type="time"
                                                    size="small"
                                                    value={state.pickupTime
                                                        .attach(Downgraded)
                                                        .get() === null ? '' : state.pickupTime
                                                            .attach(Downgraded)
                                                            .get() === '00:00' ? '' : state.pickupTime
                                                                .attach(Downgraded)
                                                                .get()}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    inputProps={
                                                        state.pickupTime.attach(Downgraded).get() != null ? {className: 'has-value'} : {}
                                                    }
                                                    onChange={(e) => {
                                                        if (e.target.value != '') {
                                                            e.target.classList.add('has-value');
                                                        }
                                                        else {
                                                            e.target.classList.remove('has-value');
                                                        }
                                                        state.pickupTime.set(e.target.value)
                                                        setTimeErr('')
                                                        handleDisableBtn()
                                                    }}
                                                    sx={{ width: 150 }}
                                                    error={
                                                        timeErr.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                    helperText={timeErr}

                                                />

                                            </Stack>
                                        </Grid>
                                        <Grid item lg={3} md={6} xs={12} sx={{ mt: 3 }}>
                                            <TextField
                                                size="small"
                                                required
                                                id="outlined-required"
                                                label="Pick-Up Location"
                                                autoComplete="off"
                                                value={state.pickupAddress.get()}
                                                onChange={(event) => { state.pickupAddress.set(event.target.value); handleDisableBtn() }}
                                                onBlur={() => validAddress('pickup')}
                                                inputProps={{ maxLength: 500 }}
                                                helperText={pickupAddressErr}
                                                error={pickupAddressErr.length > 0 ? true : false}
                                            />
                                        </Grid>
                                        <Grid item lg={3} md={6} xs={12} >
                                            <label style={{position: 'relative', bottom: '5px'}}>(following All-Star Saturday Night)</label>
                                            <TextField
                                                size="small"
                                                required
                                                id="outlined-required"
                                                label="Drop-Off Location"
                                                autoComplete="off"
                                                value={state.dropOffAddress.get()}
                                                onChange={(event) => { state.dropOffAddress.set(event.target.value); handleDisableBtn() }}
                                                onBlur={() => validAddress('dropoff')}
                                                inputProps={{ maxLength: 500 }}
                                                helperText={dropOffAddressErr}
                                                error={dropOffAddressErr.length > 0 ? true : false}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            backgroundColor: '#f8f8f8',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={{ xs: '12px', md: '14px' }}
                                            fontWeight={500}
                                            paddingLeft={1}
                                            paddingTop={1}
                                            fontFamily={'Lato'}
                                            color="primary"
                                            pb={1}>
                                            PRIMARY CONTACT FOR PLAYER REGARDING ASSN TRANSPORTATION
                                        </Typography>
                                    </Box>
                                    {/* <Divider light={false} flexItem /> */}

                                    <Grid
                                        container
                                        rowSpacing={2}
                                        columnSpacing={1}
                                        sx={{
                                            padding: 0,
                                            marginTop: 1,
                                        }}>
                                        <Grid item lg={4} md={6} xs={12} >
                                            <TextField
                                                size="small"
                                                required
                                                id="outlined-required"
                                                label="Name"
                                                autoComplete="off"
                                                value={state.priContactName.get()}
                                                onChange={(event) => {
                                                    regex.test(event.target.value)
                                                        ? state.priContactName.set(event.target.value)
                                                        : state.priContactName.set(event.target.value.trim());
                                                    handleDisableBtn()
                                                }}
                                                inputProps={{ maxLength: 50 }}
                                                onBlur={() => validateName('pri')}
                                                helperText={priContactNameErr}
                                                error={priContactNameErr.length > 0 ? true : false}
                                            />
                                        </Grid>
                                        <Grid item lg={4} md={6} xs={12} >
                                            <TextField
                                                size="small"
                                                required
                                                id="outlined-required"
                                                label="Email"
                                                autoComplete="off"
                                                value={state.priContactEmail.get()}
                                                onChange={(event) => { state.priContactEmail.set(event.target.value); handleDisableBtn() }}
                                                inputProps={{ maxLength: 250 }}
                                                onBlur={() => validateEmail('pri')}
                                                helperText={priContactEmailErr}
                                                error={priContactEmailErr.length > 0 ? true : false}
                                            />
                                        </Grid>
                                        <Grid item lg={4} md={6} xs={12}>
                                            {/* <InputMask
                                                mask="(999) 999-9999"
                                                value={
                                                    state.priContactNo.value
                                                }
                                                defaultValue={
                                                    state.priContactNo.value
                                                }
                                                onBlur={() => checkValidPhone('pri')}
                                                onChange={(
                                                    e
                                                ) =>
                                                {
                                                    state.priContactNo.set(e.target.value);
                                                    //handlePhoneChange(e,index)
                                                    // checkValidPhone(
                                                    //     e
                                                    // );
                                                    handleDisableBtn();
                                                }}>
                                                {() => (
                                                    <TextField
                                                        size="small"
                                                        required
                                                        id="outlined-required"
                                                        label="Contact No"
                                                        value={state.priContactNo.get()}
                                                        autoComplete="off"
                                                        helperText={priContactNoErr}
                                                        error={priContactNoErr.length > 0 ? true : false}
                                                    />
                                                )}
                                            </InputMask> */}
                                            <PhoneNumber
                                                name={'satNightPriContact'}
                                                placeholder="Contact No*"
                                                value={state.priContactNo.get()}
                                                onChange={(ph) => {
                                                    state.priContactNo.set(ph);
                                                    handleDisableBtn()
                                                    setPriContactNoErr('')
                                                }}
                                                required={true}
                                                helperText={priContactNoErr}
                                                error={priContactNoErr.length > 0 ? true : false}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            backgroundColor: '#f8f8f8',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={{ xs: '12px', md: '14px' }}
                                            fontWeight={500}
                                            paddingLeft={1}
                                            paddingTop={1}
                                            fontFamily={'Lato'}
                                            color="primary"
                                            pb={1}>
                                            BACKUP CONTACT FOR PLAYER REGARDING ASSN TRANSPORTATION
                                        </Typography>
                                    </Box>
                                    {/* <Divider light={false} flexItem /> */}
                                    <Grid
                                        container
                                        rowSpacing={2}
                                        columnSpacing={1}
                                        sx={{
                                            padding: 0,
                                            marginTop: 1,
                                        }}>
                                        <Grid item lg={4} md={6} xs={12} >
                                            <TextField
                                                size="small"
                                                // required
                                                id="outlined-required"
                                                label="Name"
                                                autoComplete="off"
                                                value={state.backupContactName.get()}
                                                onChange={(event) => {
                                                    regex.test(event.target.value)
                                                        ? state.backupContactName.set(event.target.value)
                                                        : state.backupContactName.set(event.target.value.trim());
                                                    handleDisableBtn()
                                                }}
                                                inputProps={{ maxLength: 50 }}
                                                onBlur={() => validateName('backup')}
                                                helperText={backupContactNameErr}
                                                error={backupContactNameErr.length > 0 ? true : false}
                                            />
                                        </Grid>
                                        <Grid item lg={4} md={6} xs={12} >
                                            <TextField
                                                size="small"
                                                // required
                                                id="outlined-required"
                                                label="Email"
                                                autoComplete="off"
                                                value={state.backupContactEmail.get()}
                                                onChange={(event) => { state.backupContactEmail.set(event.target.value); handleDisableBtn() }}
                                                inputProps={{ maxLength: 250 }}
                                                onBlur={() => validateEmail('backup')}
                                                helperText={backupContactEmailErr}
                                                error={backupContactEmailErr.length > 0 ? true : false}
                                            />
                                        </Grid>
                                        <Grid item lg={4} md={6} xs={12}>
                                            {/* <InputMask
                                                mask="(999) 999-9999"
                                                value={
                                                    state.backupContactNo.value
                                                }
                                                defaultValue={
                                                    state.backupContactNo.value
                                                }
                                                onBlur={() => checkValidPhone('backup')}
                                                onChange={(
                                                    e
                                                ) =>
                                                {
                                                    state.backupContactNo.set(e.target.value);
                                                    //handlePhoneChange(e,index)
                                                    // checkValidPhone(
                                                    //     e
                                                    // );
                                                    handleDisableBtn();
                                                }}>
                                                {() => (
                                                    <TextField
                                                        size="small"
                                                        // required
                                                        id="outlined-required"
                                                        label="Contact No"
                                                        autoComplete="off"
                                                        helperText={backupContactNoErr}
                                                        error={backupContactNoErr.length > 0 ? true : false}
                                                    />
                                                )}
                                            </InputMask> */}
                                            <PhoneNumber
                                                name={'satNightBackupContact'}
                                                placeholder="Contact No"
                                                value={state.backupContactNo.get()}
                                                onChange={(ph) => {
                                                    state.backupContactNo.set(ph);
                                                    handleDisableBtn()
                                                    // setBackupContactNoErr('')
                                                }}
                                                required={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                                {/* history.location.state.transportState */}
                                <ButtonContainer
                                    handleClick={handleSubmit}
                                    handleCancel={handleBtnCancel}
                                    loading={showLoading}
                                    showLoading={showLoading}
                                    buttonText={state.transportID.get() > 0 ? (history.location.state && history.location.state.transportState && history.location.state.transportState.requestStatus.toLowerCase() === "pending") ? 'Update & Submit' : 'Update' : 'Submit'}
                                    // disableButton={state.isDisable.get()}
                                    disableUpdateButton={state.transportID.get() > 0 ? disableBtn : false}
                                />
                            </Box>
                    }
                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: false,
                                })
                            }></CustomizedSnackbars>
                    )}
                </>
            </Box>
        </Box>
    )
}

export default {
    routeProps: {
        path: [RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_CREATE, RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_EDIT],
        component: CreateNightTransport,
    },
    name: 'CreateNightTransport',
};